module.exports = __webpack_public_path__ + "media/images/edit_over-15361605.png";